<template>
    <div class="about">
        <div class="about-container">
            <div class="about-title">
                <img src="../../Assets/logo-psflex.png" style="margin-right: 10px; width: 32px; height: 32px;"> PsFlex
            </div>
            <div class="about-author">
                Gabriel Cavecedo
            </div>
            <div class="about-date">
                Versión: {{ version }} ({{ dateCompiled }})
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'About',
        props: ['id'],
        data () {
            return {
                dateCompiled: process.env.VERSION_DATE,
                version: window.__psflex_version
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .about {
        font-size: 16px;
        font-family: 'Roboto', sans-serif;
        padding-top: 18px;
        text-align: center;
        height: calc(100% - 24px);
        overflow-x: hidden;
        overflow-y: auto;
        background-color: #F0F0F0;
        color: #444;
    }

    .about-container {
        text-align: center;
        margin-bottom: 120px;
        font-weight: bolder;
    }
    
    .about-title {
        font-size: 42px;
        padding: 0px;
        background-color: #444;
        color: #F0F0F0;
        width: 100%;
        text-shadow: 2px 2px 3px rgba(255,255,255,0.4);
    }
    
    .about-author {
        font-size: 20px;
        padding-top: 80px;
    }
    
    .about-date {
        font-size: 16px;
        padding-top: 20px;
    }

</style>


// WEBPACK FOOTER //
// src/Components/Help/About.vue